<ng-template #template>
  <ng-container *ngIf="isDisplayed">
    <div class="l-mybooking__option-item">
      <asw-next-action-item
        (clickNextAction)="onClick()"
        [canBeClicked]="canBeClicked"
        [title]="'label.pleaseSeatSelectionIndex' | staticMsg"
        [titleAria]="'reader.pleaseSeatSelection' | staticMsg"
        [textContent]="'label.pleaseSeatSelectionText' | staticMsg"
        itemId="advance-seat-selection"
      >
      </asw-next-action-item>
    </div>
  </ng-container>
</ng-template>
